exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.checkbox-position[data-v-78349a3f] {\n    padding-top: 12px;\n}\n.font-smaller[data-v-78349a3f] {\n    font-size: .75rem;\n}\n", ""]);

// exports
